import { AppLoader } from "@/components/ui";
import { useUser } from "@clerk/react";
import { RedirectToSignIn, Show, useAuth } from "@clerk/react";
import { createRootRoute } from "@tanstack/react-router";
import { PostHogProvider, usePostHog } from "posthog-js/react";
import * as React from "react";
import { AppLayout } from "./-app-layout";

const PostHogIdentify: React.FC = () => {
  const { user } = useUser();
  const posthog = usePostHog();

  React.useEffect(() => {
    if (!user) return;

    posthog.identify(user.id, {
      email: user.primaryEmailAddress?.emailAddress,
      name: user.fullName,
      first_name: user.firstName,
      last_name: user.lastName,
      avatar: user.imageUrl,
    });
  }, [posthog, user?.id]);

  return null;
};

const RootLayout: React.FC = () => {
  const { isLoaded } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={{
          api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
          ui_host: "https://us.posthog.com",
          defaults: "2026-01-30",
          capture_exceptions: true,
          debug: import.meta.env.DEV,
        }}
      >
        {!isLoaded
          ? <AppLoader />
          : (
            <>
              <Show when="signed-in">
                <PostHogIdentify />
                <AppLayout />
              </Show>

              <Show when="signed-out">
                <RedirectToSignIn />
              </Show>
            </>
          )}
      </PostHogProvider>
    </div>
  );
};

const NotFound: React.FC = () => {
  const navigate = Route.useNavigate();

  React.useEffect(() => {
    void navigate({ to: "/", replace: true });
  }, [navigate]);

  return <AppLoader />;
};

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});
